<template>
	<v-layout 
		row wrap
		align-center
		class="form-step-one"
		:class="[ isQinti ? 'back-qinti' : isLucky ? 'backL' : 'back-primary']"
	>
		<v-btn
			v-if="showForm && !isForm"
			class="form-btn-close"
			depressed
			flat
			icon
			@click="$emit('close-form')"
		>
			<v-icon color="white">close</v-icon>
		</v-btn>
		<v-flex xs12 text-xs-center>
			<h2 class="white--text w-black form-step-one-title">
				GRACIAS POR REGISTRARTE
			</h2>
		</v-flex>
		<v-flex xs12>
			<img
				src="/static/images-new/logos/logo-banner.svg"
				alt="logo casamarket"
				height="64"
				v-if="isQinti"
			/>
			<img
				src="/static/images-new/logos/logo-banner-lucky.png"
				alt="logo casamarket"
				height="64"
				v-if="isLucky"
			/>
			<img
				src="/static/images-new/logos/logo-casamarket-white-mini.svg"
				alt="logo casamarket"
				height="64"
				v-else
			/>
		</v-flex>
		<v-flex xs12>
			<h2 class="white--text w-black form-step-one-title">
				¡COMIENZA A VENDER <span>AHORA!</span>
			</h2>
		</v-flex>
		<v-flex xs12>
			<p class="white--text w-semibold form-step-one-description">
				En unos minutos uno de nuestros asesores de venta se comunicará contigo.
			</p>
		</v-flex>
	</v-layout>
</template>

<script>
	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'form-step-one',
		computed: {
			isQinti,
			isLucky,
		},
		props: {
			showForm: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-step-one {
		height: 91%;
		left: 17px;
		padding: 115px 0px 259px;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: size(large31);
			letter-spacing: normal;
			line-height: normal;
			margin: 28px auto 41px;
			max-width: 210px;

			span {
				font-size: size(big39);
			}
		}

		&-btn {
			border-radius: 5px;
			color: color(white);
			font-size: size(medium18);
			font-weight: weight(black);
			height: 64px;
			width: 205px;
		}

		&-container {
			bottom: 255px;
			position: relative;
			z-index: 1;
		}

		&-description {
			font-size: size(large);
		}
	}

	.show-form {
		.form-step-one {
			height: 100%;
			left: 0px;
			padding: 129px 0px;
			top: 0px;
			width: 100%;
		}
	}

	.back-primary {
		background-color: color(primary);
	}

	.back-qinti {
		background-color: #e4278e;
	} 
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-step-four.vue